import { useEffect, useState } from "react";
import { useLang } from "../../context/LangContext";
import { LANGS } from "../../lib/editions";
import { Flag } from "./Flag";

const Group = ({ title, children }) => (
  <div className="border-b border-[#120E1F]/5 pb-4 space-y-2"><p className="text-xs uppercase tracking-[0.18em] text-[#707783] font-semibold">{title}</p>{children}</div>
);

const Check = ({ checked, onChange, label, count, testid }) => (
  <label className="flex items-center gap-2.5 text-sm cursor-pointer py-0.5 hover:text-[#6E3FB8] transition-colors" data-testid={testid}>
    <input type="checkbox" checked={checked} onChange={onChange} className="accent-[#6E3FB8] h-4 w-4" />
    <span className="flex-1 flex items-center gap-2">{label}</span>{count != null && <span className="text-[11px] text-[#707783] font-mono">{count}</span>}
  </label>
);

export const ShopFilters = ({ f, setF, facets }) => {
  const { t, tr, lang } = useLang();
  const [price, setPrice] = useState({ min: f.min_price || "", max: f.max_price || "" });
  useEffect(() => { setPrice({ min: f.min_price || "", max: f.max_price || "" }); }, [f.min_price, f.max_price]);
  const toggle = (key, v) => { const cur = f[key] ? f[key].split(",") : []; setF(key, (cur.includes(v) ? cur.filter((x) => x !== v) : [...cur, v]).join(",")); };
  const has = (key, v) => (f[key] || "").split(",").includes(v);
  const fc = facets || { language: {}, category: {}, set_name: {}, condition: {} };
  return (
    <div className="space-y-4" data-testid="shop-filters">
      <Group title={tr("Sprache", "Language")}>
        {LANGS.map((l) => <Check key={l.code} testid={`filter-lang-${l.slug}`} checked={has("language", l.code)} onChange={() => toggle("language", l.code)} count={fc.language[l.code] || 0}
          label={<><Flag code={l.code} />{lang === "en" ? l.en : l.de}</>} />)}
      </Group>
      <Group title={tr("Produkttyp", "Product type")}>
        {Object.keys(t("cat")).map((c) => <Check key={c} testid={`filter-cat-${c}`} checked={has("category", c)} onChange={() => toggle("category", c)} count={fc.category[c] || 0} label={t("cat")[c]} />)}
      </Group>
      {Object.keys(fc.set_name).length > 0 && <Group title="Set">
        {Object.entries(fc.set_name).sort((a, b) => b[1] - a[1]).map(([s, n]) => <Check key={s} testid={`filter-set-${s}`} checked={has("set", s)} onChange={() => toggle("set", s)} count={n} label={s} />)}
      </Group>}
      <Group title={tr("Preis (€)", "Price (€)")}>
        <form className="flex gap-2 items-center" onSubmit={(e) => { e.preventDefault(); setF({ min_price: price.min, max_price: price.max }); }}>
          <input type="number" min="0" placeholder="min" value={price.min} onChange={(e) => setPrice({ ...price, min: e.target.value })} className="w-20 rounded-lg border px-2 py-1.5 text-sm" data-testid="filter-price-min" />
          <span>–</span>
          <input type="number" min="0" placeholder="max" value={price.max} onChange={(e) => setPrice({ ...price, max: e.target.value })} className="w-20 rounded-lg border px-2 py-1.5 text-sm" data-testid="filter-price-max" />
          <button className="btn-outline !px-3 !py-1.5 text-xs" data-testid="filter-price-apply">OK</button>
        </form>
      </Group>
      <Group title={tr("Verfügbarkeit", "Availability")}>
        <Check testid="filter-avail-in-stock" checked={f.availability_status === "in_stock"} onChange={() => setF("availability_status", f.availability_status === "in_stock" ? "" : "in_stock")} label={tr("Auf Lager", "In stock")} />
        <Check testid="filter-avail-preorder" checked={f.availability_status === "preorder"} onChange={() => setF("availability_status", f.availability_status === "preorder" ? "" : "preorder")} label={tr("Vorbestellung", "Pre-order")} />
      </Group>
      {Object.keys(fc.condition).length > 0 && <Group title={tr("Zustand", "Condition")}>
        {Object.entries(fc.condition).map(([c, n]) => <Check key={c} testid={`filter-cond-${c}`} checked={has("condition", c)} onChange={() => toggle("condition", c)} count={n} label={c === "Sealed" ? tr("Neu & versiegelt", "New & sealed") : c} />)}
      </Group>}
    </div>
  );
};
